var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.vertical ? 'mx-3' : 'my-3'},[_c('v-divider',{staticClass:"line-border",staticStyle:{"border-radius":"15%"},style:({ width: _vm.long, 'border-width': _vm.borderWidthAdditional }),attrs:{"vertical":_vm.vertical}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }